var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.hideLoadingSpinner)?_c('LoadingSpinner',{attrs:{"is-loading":_vm.isLoading}}):_vm._e(),_c('router-view'),_c('ToastManager')],1)}
var staticRenderFns = []

export { render, staticRenderFns }